import { defineMessages } from 'react-intl'

export default defineMessages({
    searchParkingHere: {
        defaultMessage: 'Buscar parkings aquí',
    },
    full: {
        defaultMessage: 'Completo',
    },
    checkPrice: {
        defaultMessage: 'Consultar precios',
    },
    onlyViat: {
        defaultMessage: 'Solo disponible con Via-T',
    },
    cantSearchParkingHere: {
        defaultMessage: 'Acércate para poder buscar',
    },
})
